import React, { useEffect, useState } from "react";
import Ticket from "./Ticket";
import TicketList from "./TicketList";
import { fetchTicketCount, fetchTicketList } from "../../actions/tickets-action";
import { useSelector } from "react-redux";
import { COOKIE, VERTICALS } from "../../constants/app-constant";
import { getCookie } from "../../utility/cookieProvider";
import moment from 'moment';

const Tickets = ({
  toggleChatbot
}) => {
  const masterUser =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.masterUser
    );
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const userId = getCookie(COOKIE.CONCEPT_USER_ID);

  const [isDataLoading,setIsDataLoading] = useState(true)
  const [currentPage,setCurrentPage] = useState(0)
  const [totalPage,setTotalPage] = useState(1)
  const [pagination,setPagination] = useState({})
  const [ticketLists,setTicketLists] = useState([])
  const [userList,setUserList] = useState([])
  const [mediaType,setMediaType] = useState(VERTICALS.V_PRINT_AND_ONLINE_OLD)
  const [status,setStatus] = useState(["0","1","2"])
  const [dateValue,setDateValue] = useState(null)
  const [subUserValue,setSubUserValue] = useState()
  const [monthCount,setMonthCount] = useState({})
 const [category,setcategory] = useState(0)
  useEffect(() => {
    if(Object.keys(selectedClient).length){
      async function fetchCount() {
        let tObj = {
          from_date : dateValue != null?moment(dateValue[0]).format("DD-MM-YYYY"):moment().startOf("month").format("DD-MM-YYYY"),
          to_date : dateValue != null?moment(dateValue[1]).format("DD-MM-YYYY"):moment().endOf("month").format("DD-MM-YYYY"),
          client_id : selectedClient.id
        }
        let tData = await fetchTicketCount(tObj)
        if(Object.keys(tData).length){
          setMonthCount(tData)
        }
        else{
          setMonthCount({})
        }
      }

      fetchCount()
    }
  },[selectedClient,dateValue])

  useEffect(() => {
     console.log("API call useEffect triggered");
    async function fetchData() {
      setIsDataLoading(true)
      if(masterUser != undefined && Object.keys(selectedClient).length){
        let tObj = {
          user_type : Object.keys(masterUser).length && !subUserValue?0:1,
          user_id : subUserValue?subUserValue:Object.keys(masterUser).length?0:userId,
          perPage : 50,
          page : currentPage,
          client_id : selectedClient.id,
          list : true,
          master_ids : Object.keys(masterUser).length && !subUserValue?masterUser.id:undefined,
          master_user_id : Object.keys(masterUser).length && !subUserValue?userId:undefined,
          status : status,
          category: category
        }
        console.log("line no 48 tobj ",tObj)
        if(mediaType !== VERTICALS.V_PRINT_AND_ONLINE_OLD){
          if(mediaType == VERTICALS.V_PRINT_AND_ONLINE){
            tObj.media_type = [VERTICALS.V_PRINT,VERTICALS.V_ONLINE]
          }
          else{
            tObj.media_type = [mediaType]
          }
        }
        if(dateValue != null){
          tObj.from_date = moment(dateValue[0]).format("DD-MM-YYYY")
          tObj.to_date = moment(dateValue[1]).format("DD-MM-YYYY")
        }
      
        let tData = await fetchTicketList(tObj)
        if(Object.keys(tData).length){
          setTicketLists(tData.data.data)
          setUserList(tData.data.userDetails)
          setTotalPage(tData.pagination.pages)
          if(currentPage == 0){
            setPagination(tData.pagination)
          }
        }
        else{
          setTicketLists([])
          setUserList([])
          setTotalPage(1)
          if(currentPage == 0){
            setPagination({})
          }
        }
        setIsDataLoading(false)
      }
    }
    
    fetchData()
    
  },[masterUser,selectedClient,currentPage,mediaType,status,dateValue,subUserValue,category])

  return (
    <div >
      {
        <TicketList 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          ticketLists={ticketLists}
          totalPage={totalPage}
          userList = {userList}
          isDataLoading={isDataLoading}
          pagination={pagination}
          mediaType = {mediaType}
          setMediaType={setMediaType}
          setStatus={setStatus}
          setDateValue={setDateValue}
          setSubUserValue={setSubUserValue}
          monthCount = {monthCount}
          setcategory = {setcategory}
          category = {category}
          
        />
      }
      {/* <ChatInput sendMessage={sendMessage} /> */}
    </div>
  );
};

export default Tickets;
